import { environment } from '@environments/environment';
import { constantsPattern as prod } from './prod/defaults';
import { constantsPattern as test } from './test/defaults';
import { constantsPattern as dev } from './dev/defaults';
import { constantsPattern as headless } from './headless/defaults';
import { constantsPattern as devJourney } from './dev/outage-journey.project';
import { constantsPattern as headlessJourney } from './headless/outage-journey.project';
import { constantsPattern as devOutageMap } from './dev/outage-map.project';
import { constantsPattern as headlessOutageMap } from './headless/outage-map.project';
import { constantsPattern as devVOC } from './dev/voc.project';
import { constantsPattern as headlessVOC } from './headless/voc.project';

export function getConstants() {
  if (environment.production) {
    return prod;
  }
  if (environment.isTest) {
    return test;
  }
  if (environment.isHeadless) { // devEnvironment reflects local env and may be headless
    if (environment.isJourney) {
      return headlessJourney;
    }
    if (environment.isOutageMap) {
      return headlessOutageMap;
    }
    if (environment.isVOC) {
      return headlessVOC;
    }
    return headless;
  }
  if (environment.devEnvironment) {
    if (environment.isJourney) {
      return devJourney;
    }
    if (environment.isVOC) {
      return devVOC;
    }
    if (environment.isOutageMap) {
      return devOutageMap;
    }
    return dev;
  }

  return prod;
}
